import { s } from "./index803.mjs";
import { u as e } from "./index824.mjs";
var o = s, d = e, a = o("keys"), u = function(r) {
  return a[r] || (a[r] = d(r));
};
export {
  u as s
};
